var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import React from 'react';
import { FormGroup } from "../../Forms";
import { Captcha } from "../../ReactReduxForms";
import { Translate } from "../../I18N";



const CaptchaComponent = ({ remote, refresh }) => /*#__PURE__*/
_jsx(FormGroup, { model: ".captcha" }, "captcha", /*#__PURE__*/
_jsx("ul", { className: "search__filter" }, void 0, /*#__PURE__*/
_jsx("li", {}, void 0, /*#__PURE__*/
_jsx("label", {}, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "Captcha"), /*#__PURE__*/
_jsx("span", { className: "required" }, void 0, "*")
)
), /*#__PURE__*/
_jsx("li", { className: "wide" }, void 0, /*#__PURE__*/
_jsx(Captcha, { remote: remote, refresh: refresh, model: ".captcha" })
)
)
);


export const FormCaptcha = /*#__PURE__*/React.memo(CaptchaComponent);